<div class="sp-mb-16">{{ "send_for_approval_description_v1" | localize: { reviewersNeeded: session.workflow.reviewers } }}</div>

<form-group>
  <assignee-form-item [labelText]="'select_reviewers' | localize" [request]="peopleSelectorRequest" [value]="modalData.selectedUsers" controlName="selectReviewers"> </assignee-form-item>
</form-group>
